 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"BuyerRegister":"BuyerRegister","Events":"Events","Financial":"Financial","Invoice":"Invoice","administrativo":"administrativo","blocked-access":"blocked-access","company":"company","company-configurations":"company-configurations","company-data":"company-data","company-documentation":"company-documentation","company-invite-suppliers":"company-invite-suppliers","company-keys":"company-keys","company-registry":"company-registry","company-size":"company-size","company-users":"company-users","dashboard":"dashboard","forgot-password":"forgot-password","listagem-dispensas":"listagem-dispensas","listagem-notificações":"listagem-notificações","listagem-pregoes":"listagem-pregoes","main-contract-points":"main-contract-points","manuals":"manuals","not-found-page":"not-found-page","profile":"profile","profile-data":"profile-data","profile-password":"profile-password","profile-pin":"profile-pin","reset-password":"reset-password","terms-of-use":"terms-of-use","validateCompany":"validateCompany","viewCompanyData":"viewCompanyData","viewCompanyDocuments":"viewCompanyDocuments","viewCompanyRegistry":"viewCompanyRegistry","viewCompanyType":"viewCompanyType","viewCompanyUsers":"viewCompanyUsers"}[chunkId]||chunkId) + "." + {"BuyerRegister":"4096728c","Events":"bb2359f1","Financial":"969cc951","Invoice":"03a62a3a","administrativo":"5d9130a2","blocked-access":"e6c774cd","company":"77ffb9a1","company-configurations":"c326ad9a","company-data":"bd93591d","company-documentation":"220f5ded","company-invite-suppliers":"47da89a6","company-keys":"d5be6995","company-registry":"8bc2f084","company-size":"57a0d8fe","company-users":"f790f4f2","dashboard":"1122a0b1","forgot-password":"2eae8c45","listagem-dispensas":"7e980afb","listagem-notificações":"8e7694f1","listagem-pregoes":"7c34c51f","main-contract-points":"084ae6d8","manuals":"b0eecc0f","not-found-page":"133100be","profile":"d5fe9027","profile-data":"339999ea","profile-password":"b007e790","profile-pin":"4759968b","reset-password":"84824a76","terms-of-use":"08c93dca","validateCompany":"6a2381d8","viewCompanyData":"3a1ffe2e","viewCompanyDocuments":"bbc82a02","viewCompanyRegistry":"adf43788","viewCompanyType":"198b5670","viewCompanyUsers":"0d674589"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"BuyerRegister":1,"Events":1,"Financial":1,"Invoice":1,"blocked-access":1,"company":1,"company-documentation":1,"company-invite-suppliers":1,"company-keys":1,"company-registry":1,"company-size":1,"company-users":1,"dashboard":1,"forgot-password":1,"listagem-dispensas":1,"listagem-notificações":1,"listagem-pregoes":1,"main-contract-points":1,"manuals":1,"not-found-page":1,"profile-password":1,"profile-pin":1,"reset-password":1,"terms-of-use":1,"validateCompany":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"BuyerRegister":"BuyerRegister","Events":"Events","Financial":"Financial","Invoice":"Invoice","administrativo":"administrativo","blocked-access":"blocked-access","company":"company","company-configurations":"company-configurations","company-data":"company-data","company-documentation":"company-documentation","company-invite-suppliers":"company-invite-suppliers","company-keys":"company-keys","company-registry":"company-registry","company-size":"company-size","company-users":"company-users","dashboard":"dashboard","forgot-password":"forgot-password","listagem-dispensas":"listagem-dispensas","listagem-notificações":"listagem-notificações","listagem-pregoes":"listagem-pregoes","main-contract-points":"main-contract-points","manuals":"manuals","not-found-page":"not-found-page","profile":"profile","profile-data":"profile-data","profile-password":"profile-password","profile-pin":"profile-pin","reset-password":"reset-password","terms-of-use":"terms-of-use","validateCompany":"validateCompany","viewCompanyData":"viewCompanyData","viewCompanyDocuments":"viewCompanyDocuments","viewCompanyRegistry":"viewCompanyRegistry","viewCompanyType":"viewCompanyType","viewCompanyUsers":"viewCompanyUsers"}[chunkId]||chunkId) + "." + {"BuyerRegister":"91abb546","Events":"b275941c","Financial":"a0952394","Invoice":"d74a85af","administrativo":"31d6cfe0","blocked-access":"b80604fe","company":"cd799ec9","company-configurations":"31d6cfe0","company-data":"31d6cfe0","company-documentation":"47af25bd","company-invite-suppliers":"7aa374ab","company-keys":"8645e470","company-registry":"76ea69e1","company-size":"c34e8198","company-users":"05de4ca8","dashboard":"9e3aae95","forgot-password":"d63792db","listagem-dispensas":"99d3ae01","listagem-notificações":"26478b58","listagem-pregoes":"427150fc","main-contract-points":"bb1d847b","manuals":"8f0b739e","not-found-page":"4b2d7a56","profile":"31d6cfe0","profile-data":"31d6cfe0","profile-password":"48ca42f0","profile-pin":"35200cd1","reset-password":"5bf0cf72","terms-of-use":"9ba37257","validateCompany":"9a1d3991","viewCompanyData":"31d6cfe0","viewCompanyDocuments":"31d6cfe0","viewCompanyRegistry":"31d6cfe0","viewCompanyType":"31d6cfe0","viewCompanyUsers":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
